module.exports = __webpack_public_path__ + "static/img/floatRightImg2.7842870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floatRightImg2.png
// module id = WeRU
// module chunks = 2